import React, { useState } from 'react';
import { NeuroMessage, useProduct } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components';
import PropTypes from 'prop-types';

const Product = ({ product, onClick }) => {
  const {
    disclosures,
    features,
    name,
    onProductActionClick,
    url
  } = useProduct(product);

  const [ showFeatures, setShowFeatures ] = useState(false);
  const [ showDisclosures, setShowDisclosures ] = useState(false);
  
  const messageContext = useNeuroMessages();
  const cssBEM = 'product';
  const productAction = messageContext.getMessage(`${product.id}.actionType`);
  const productUrl = messageContext.getMessage(`${product.id}.actionType.url`);
  const productUrlClicked = () => onProductUrlClick({ actionName: 'productUrlClicked', value:'learnMore', productId: product.id });
  const learnMoreClicked = () => onProductActionClick({ actionName:'productDetailsClicked', value:'learnMore'});
  const onProductUrlClick = () => onProductUrlClick({ actionName: 'productUrlClicked', productId: product.id});

  const renderProductName = () => {
    return name.length ?
    <div className={`${cssBEM}__header`}>
      <h2><NeuroMessage id={`${product.id}.name`} onClick={onProductUrlClick} /></h2>
    </div> : null;
  };

  const renderProductDescription = () => {
    const id = `${product.id}.description`;
    return (
      <div className={`${cssBEM}__description`}>
        <NeuroMessage id={id} tagName="span" />
        { url && 
          <span className={`${cssBEM}__url`} onClick={learnMoreClicked}><a href={url} target="_blank" rel="noopener noreferrer">Learn more</a></span>
        }
      </div>
    )
  }

  const renderProductFeatures = () => {
    const iconClass = showFeatures ?  "fa fa-minus-circle" : "fa fa-plus-circle";
    return features.length ?
    <div className={`${cssBEM}__features`}>
      <div role="button" onClick={() => { setShowFeatures(!showFeatures)}}>
        <NeuroMessage id='products.features.title' tagName='span' className={`${cssBEM}__features-title`} /><i className={iconClass} aria-hidden="true"></i>
      </div>
      { showFeatures &&
        <ul>{features.map( (f,i) => <li key={i}>{f}</li>)}</ul>
      }     
    </div> : null;
  };

  const renderProductDisclosures = () => {
    const iconClass = showDisclosures ?  "fa fa-minus-circle" : "fa fa-plus-circle";
    return disclosures.length ?
      <div className={`${cssBEM}__disclosures`}>
        <div className={`${cssBEM}__disclosures-toggle`} role="button" onClick={() => { setShowDisclosures(!showDisclosures)}}>
          <NeuroMessage id='products.disclosures.title'  tagName='span' className={`${cssBEM}__disclosures-title`} /><i className={iconClass} aria-hidden="true"></i>
        </div>
        { showDisclosures &&
          disclosures.map( (f,i) => <NeuroMessage id={`${product.id}.disclosures.${i+1}`} tagName="div" />)
        } 
      </div> : null;
  };

  const renderProductButton = () => {
    return <div className={`${cssBEM}__action`}><button className="btn btn-secondary" onClick={ onProductClick }>
      <NeuroMessage id={ `${product.id}.actionType.buttonText` } />
    </button></div>;
  }

  const onProductClick = () => {
    onProductActionClick({
      actionName: 'productApplyClicked'
    });
    onClick({
      productId: product.id,
      productAction: productAction,
      productUrl: productUrl
    });
  }

  return <div className={cssBEM} key={product.id}>
    { renderProductName() }
    { renderProductDescription() }
    { renderProductButton() }
    { renderProductFeatures() }
    { renderProductDisclosures() }
  </div>
};

Product.propTypes = {
  product: PropTypes.object.isRequired
};

export default Product;
